// extracted by mini-css-extract-plugin
export default {"button":"CircleArrowButton_button__p3mo+"};